module.exports = __webpack_public_path__ + "img/19-FCP-reflect-on-your-on-campus-work-experience.4fe825dc.svg";